module.exports = __webpack_public_path__ + "ae15d82b14ddf9b13b03d2c860c7e76d.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icon-date.svg
// module id = 96
// module chunks = 0